import { dollarsToSatoshis } from "../../utils";
/**
 * Validates the product rows an agency or advertiser is saving.
 * A row without a cpm is valid: it deletes that rate.
 */
export const validateProductRates = (_item, value) => {
    if (value === undefined || value === null) {
        return undefined;
    }
    if (!Array.isArray(value)) {
        return "Products must be a list.";
    }
    for (const row of value) {
        if (!row?.id) {
            return "Every product row needs a product ID.";
        }
        if (row.cpm === undefined || row.cpm === null) {
            continue;
        }
        if (typeof row.cpm !== "number" || !Number.isFinite(row.cpm) || row.cpm < 0) {
            return "Retail CPM can't be negative or non-numeric.";
        }
        // Satoshi values beyond this lose precision as a JS number before reaching the backend.
        if (dollarsToSatoshis(row.cpm) > Number.MAX_SAFE_INTEGER) {
            return "Retail CPM is too large.";
        }
    }
    return undefined;
};
//# sourceMappingURL=validators.js.map